<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="672px" :before-close="closeModal">
    <AlertCheckPayment class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Dados cadastrados com sucesso!
    </h3>
    <p class="c-ndarkfour text-center">
        Você já completou o cadastro da sua empresa! Agora, para enviar o cadastro<br>
        para análise, é só completar o cadastro dos sócios.
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="saveAndClose"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Salvar e sair
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="registerPartners">
            Cadastrar sócios
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertCheckPayment from '@/components/icons/AlertCheckPayment'
export default {
    components: {
      AlertCheckPayment
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        saveAndClose() {
            this.$emit('closeModal', false)
            //this.$router.push(`/company/register/${this.$route.params.idCNPJ}/message`)
            window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
        },
        registerPartners() {
            this.$emit('closeModal', false)
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/partner/message`)
        }
    },
}
</script>

<style>
</style>